import { useQuery } from '@tanstack/react-query'
import { createApiCall } from 'services'
import type { Product } from 'types'

type UseProductParams = {
  productId: string
}

type UseProductResult = {
  data: Product | null
  isLoading: boolean
  isError: boolean
  error: Error | null
  refetch: () => void
}

export const useProduct = (
  params: UseProductParams,
  options?: { enabled?: boolean }
): UseProductResult => {
  const query = useQuery({
    queryKey: ['products', 'detail', params.productId],
    queryFn: async () => {
      const response = await createApiCall({
        method: 'GET',
        url: `/products/admin/${params.productId}`,
      })
      return response.data as Product
    },
    enabled: options?.enabled !== false && !!params.productId,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return {
    data: query.data || null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  }
}
